import makeStyles from '@mui/styles/makeStyles';

type Props = {
  onlyText: boolean;
};

export const useStyles = makeStyles(() => ({
  content: {
    display: "flex",
    flexDirection: "row",
  },

  img: {
    maxHeight: "160px",
  },

  mainText: {
    color: "#98A2B3",
    fontFamily: "Manrope",
    fontSize: ({ onlyText }: Props) => (onlyText ? "14px" : "24px"),
    fontStyle: "normal",
    fontWeight: ({ onlyText }: Props) => (onlyText ? 600 : 500),
    lineHeight: ({ onlyText }: Props) => (onlyText ? "20px" : "32px"),
    textAlign: "center",
    width: "100%",
  },

  root: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
  },

  secondaryText: {
    color: "#98A2B3",
    fontFamily: "Manrope",
    fontSize: ({ onlyText }: Props) => (onlyText ? "12px" : "14px"),
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: ({ onlyText }: Props) => (onlyText ? "0.4px" : "0.25px"),
    lineHeight: ({ onlyText }: Props) => (onlyText ? "16px" : "20px"), //* 142.857% */
    textAlign: "center",
    width: "100%",
  },

  texts: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: ({ onlyText }: Props) => (onlyText ? "0px" : "16px"),
    justifyContent: "center",
    maxWidth: "250px",
  },
}));
